import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  NbActionsModule,
  NbButtonModule,
  NbContextMenuModule,
  NbIconModule,
  NbLayoutModule,
  NbMenuModule,
  NbSearchModule,
  NbSelectModule,
  NbSidebarModule,
  NbThemeModule,
  NbUserModule,
} from '@nebular/theme';
import {NbEvaIconsModule} from '@nebular/eva-icons';
import {NbSecurityModule} from '@nebular/security';

import {DashoardCopyrightComponent, FooterComponent, HeaderComponent, TinyMCEComponent} from './components';
import {
  AuctionStatusPipe,
  CapitalizePipe,
  DatePipe,
  DateTimePipe,
  LimitTextPipe,
  MoneyPipe,
  NumberWithCommasPipe,
  OrderStatusPipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  TransactionTypePipe
} from './pipes';
import {OneColumnLayoutComponent, ThreeColumnsLayoutComponent, TwoColumnsLayoutComponent} from './layouts';
import {DEFAULT_THEME} from './styles/theme.default';
import {COSMIC_THEME} from './styles/theme.cosmic';
import {CORPORATE_THEME} from './styles/theme.corporate';
import {DARK_THEME} from './styles/theme.dark';

import {
  ButtonModule,
  ConfirmationService,
  MessageService,
  OverlayPanelModule,
  TableModule,
  ToolbarModule,
} from "primeng";
import {RippleModule} from "primeng/ripple";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {NotificationService} from "../services";
import {KlConfirmDialogModule} from "../@components/confirm-dialog/confirm-dialog.module";
import {NumberOfSeatPipe} from "./pipes/number-of-seat.pipe";

const PRIME_MODULES = [
  ButtonModule,
  RippleModule,
  TableModule,
  OverlayPanelModule,
  TranslateModule,
  ToolbarModule
];

const NB_MODULES = [
  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbSecurityModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbEvaIconsModule,
];
const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  DashoardCopyrightComponent,
  TinyMCEComponent,
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
];
const PIPES = [
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
  LimitTextPipe,
  MoneyPipe,
  OrderStatusPipe,
  TransactionTypePipe,
  AuctionStatusPipe,
  DatePipe,
  DateTimePipe,
  NumberOfSeatPipe
];

@NgModule({
  imports: [CommonModule, ...NB_MODULES, ...PRIME_MODULES, KlConfirmDialogModule],
  exports: [CommonModule, ...PIPES, ...COMPONENTS],
  declarations: [...COMPONENTS, ...PIPES],
  providers: [NotificationService, MessageService, TranslateService, ConfirmationService]
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        ...NbThemeModule.forRoot(
          {
            name: 'default',
          },
          [ DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME, DARK_THEME ],
        ).providers,
      ],
    };
  }
}
